const PrivacyPolicy = () => {
  return (
      <div className="min-h-screen bg-white">
      {/* Header Spacer */}
      <div className="h-20"></div>

      {/* Main Content Container */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
    
          {/* Privacy Policy Header Block */}
          <div className="mb-8">
            <h1 className="text-3xl font-bold text-gray-900 mb-4">PRIVACY POLICY</h1>
            <p className="text-blue-600 text-sm mb-2">Last Updated: 8/1/2025</p>
            <p className="text-gray-600 text-sm">
              This Privacy Policy is provided for informational purposes only and does not constitute legal advice. Please consult with 
              licensed legal counsel to ensure compliance with all applicable laws.
            </p>
          </div>

          {/* Privacy Policy Sections - Indented from main title */}
          <div className="space-y-6 pl-8">
            <div>
              <h2 className="text-lg font-bold text-gray-900 mb-3">1. Data We Collect</h2>
              <ul className="list-disc pl-6 space-y-1 text-gray-600 text-sm">
                <li><strong>Contact details:</strong> Name, phone number, email, service address</li>
                <li><strong>Service details:</strong> Type of problems to code solve, requested appointment times, property specifications</li>
                <li><strong>Payment information:</strong> Billing address, payment method (we do not store complete card numbers or financial)</li>
                <li><strong>Cookies and analytics data:</strong> IP address, browser type, device information, and usage patterns via tools like Google Analytics</li>
              </ul>
            </div>

            <div>
              <h2 className="text-lg font-bold text-gray-900 mb-3">2. How Data is Collected</h2>
              <ul className="list-disc pl-6 space-y-1 text-gray-600 text-sm">
                <li>Directly from users via contact forms, phone calls, emails, and online bookings</li>
                <li>Through third-party platforms like Google Reviews System or Facebook lead inquiries via submitted</li>
                <li>Automatically through cookies and analytics implemented in the website tools</li>
              </ul>
            </div>

            <div>
              <h2 className="text-lg font-bold text-gray-900 mb-3">3. Why We Collect Data</h2>
              <p className="text-gray-600 text-sm leading-relaxed mb-2">
                Data collected is required to deliver requested or emergency calls:
              </p>
              <ul className="list-disc pl-6 space-y-1 text-gray-600 text-sm">
                <li>To provide quotes, invoices, and scheduling information</li>
                <li>To ensure address functionality, validate, dispatch, and perform analytics</li>
                <li>To follow billing, tax preparation, legal liabilities</li>
              </ul>
            </div>

            <div>
              <h2 className="text-lg font-bold text-gray-900 mb-3">4. How and With Whom We Share Data</h2>
              <p className="text-gray-600 text-sm leading-relaxed mb-2">We never sell your data. We may share it for the following:</p>
              <ul className="list-disc pl-6 space-y-1 text-gray-600 text-sm">
                <li><strong>Service providers:</strong> Payment processors, website hosting, and analytics tools</li>
                <li><strong>Legal or regulatory authorities:</strong> When required by law or to protect rights and safety</li>
              </ul>
            </div>

            <div>
              <h2 className="text-lg font-bold text-gray-900 mb-3">5. Cookie and Tracking Policy</h2>
              <p className="text-gray-600 text-sm leading-relaxed mb-2">Our Site uses cookies to:</p>
              <ul className="list-disc pl-6 space-y-1 text-gray-600 text-sm">
                <li>Track functionality and secure session management</li>
                <li>Analytics and performance optimization</li>
                <li>Marketing (remarketing to show users electronic content, Facebook)</li>
              </ul>
            </div>

            <div>
              <h2 className="text-lg font-bold text-gray-900 mb-3">6. Data Security Practices</h2>
              <p className="text-gray-600 text-sm leading-relaxed">
                We implement industry-standard encryption, secure payment gateways, and restricted access to personal data. However, no online transmission is 
                100% secure, and we disclaim liability for unauthorized breaches beyond our reasonable control.
              </p>
            </div>

            <div>
              <h2 className="text-lg font-bold text-gray-900 mb-3">7. User Rights (CCPA and GDPR)</h2>
              <ul className="list-disc pl-6 space-y-1 text-gray-600 text-sm">
                <li><strong>Access:</strong> Get the details or copy of data provided you to this about you</li>
                <li><strong>Correction:</strong> Request that we update inaccurate information if any data provide others needs required to retain records</li>
                <li><strong>Opt-Out:</strong> You may opt out of marketing communications at any time</li>
                <li><strong>California Residents:</strong> Have the right under CCPA to request details on data use and request deletion</li>
              </ul>
              <p className="text-gray-600 text-sm leading-relaxed mt-2">
                To exercise these rights: email <a href="mailto:mountoliveplumbing@gmail.com" className="text-blue-600 hover:underline">mountoliveplumbing@gmail.com</a>
              </p>
            </div>

            <div>
              <h2 className="text-lg font-bold text-gray-900 mb-3">8. Data Retention</h2>
              <p className="text-gray-600 text-sm leading-relaxed">
                Customer data is retained only as long as necessary to provide services, comply with legal obligations, and maintain service history for warranties or 
                future service referencing.
              </p>
            </div>

            <div>
              <h2 className="text-lg font-bold text-gray-900 mb-3">9. Children's Privacy</h2>
              <p className="text-gray-600 text-sm leading-relaxed">
                Our services are not directed to individuals under the age of 13, and we do not knowingly collect personal data from children.
              </p>
            </div>

            <div>
              <h2 className="text-lg font-bold text-gray-900 mb-3">10. Changes to Privacy Policy</h2>
              <p className="text-gray-600 text-sm leading-relaxed">
                Updates will be reflected on this website. Any updates will be posted on this page with a new "Last Updated" date.
              </p>
            </div>

            <div>
              <h2 className="text-lg font-bold text-gray-900 mb-3">11. Contact Information</h2>
              <p className="text-gray-600 text-sm leading-relaxed mb-2">For privacy concerns, data access, or deletion requests, contact:</p>
              <ul className="list-disc pl-6 space-y-1 text-gray-600 text-sm">
                <li>Email: <a href="mailto:mountoliveplumbing@gmail.com" className="text-blue-600 hover:underline">mountoliveplumbing@gmail.com</a></li>
                <li>Phone: <a href="tel:+19738620606" className="text-blue-600 hover:underline">(973) 862-0606</a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
   
  );
  };

export default PrivacyPolicy;